import React, { useState, useEffect } from "react"
import { envAwarePost } from "../../util/util";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import classes from "./Settings.module.css"
import { useSelector } from "react-redux"
import Spinner from "react-bootstrap/Spinner"

function EventReminders({ eventReminders, setEventReminders, isEventReminderLoading }) {
    const isTime24Hour = Number(useSelector(state => state.users.current_user.is_24_hour_time))
    function remindersDBupdate(name, time, timeMode, checked) {
        if (checked === false) {
            checked = "0"
        } else {
            checked = "1"
        }
        let ISOtime = getISO24(time, timeMode, isTime24Hour)

        envAwarePost('/api/events/api.php', {
            action: "updateEventReminder",
            event_type: name,
            time: ISOtime,
            enabled: checked
        })

    }

    const getISO24 = (hr, timeMode, isTime24Hour) => {
        // if 24 hour then just add zero seconds and minutes
        if (isTime24Hour) {
            return hr + ":00:00"
        }

        // if 12 hour then figure out AM/PM
        if (timeMode !== '24' && !(hr >= 1 && hr <= 12)) {
            //alert('For AM/PM, hours must be between 1 and 12.');
            return false;
        } else if (!(hr >= 0 && hr <= 24)) {
            //alert('please input an hour between 0 and 24.');
            return false;
        }

        const pmOffset = timeMode === 'PM' ? 12 : 0;
        const hrEdgeCase = hr === 12 && timeMode !== '24' ? 0 : Number(hr);

        const absoluteHr = hrEdgeCase + pmOffset;
        const isoTime = (absoluteHr < 10 ? '0' : '') + (absoluteHr) + ':00:00';

        return isoTime;
    }

    console.log(isEventReminderLoading,"isEventLoading");
    return (
        <Card className={`${classes.cardWidth} mb-5 shadow`}>
            <Card.Body>
                <h4>Client Reminders</h4>
                <p>Customize if and when clients are reminded if they haven't completed a workout, task or nutrition by a certain time.</p>
                <hr className="mt-1" />
                {/* <div className="text-right">select</div> */}

                {isEventReminderLoading ?
                   	<Spinner animation="border" variant="primary" /> :
                    eventReminders && Object.entries(eventReminders).map(([name, value]) => {
                        let checked = value.enabled;
                        let timeMode = value.timeMode;
                        let time = value.time;

                        if (checked == "1" || checked === true) {
                            checked = true
                        } else {
                            checked = false;
                        }

                        return (
                            <Row key={name} className="mt-3 d-flex align-items-center mb-4">
                                <Col className="" style={{ textTransform: "capitalize", minWidth: "300px" }}>
                                    {name === "simplified_nutrition" ? "Simplified Nutrition" : name}
                                </Col>

                                <Col style={{ minWidth: "300px" }} className="d-flex align-items-center justify-content-end">
                                    <Form.Group className="d-block mb-0" controlId={name}>
                                        <input name={name}
                                            value={time}
                                            style={{ fontSize: "1.2rem", textAlign: "center", minWidth: "100px" }}
                                            className="text-center form-control-alternative"
                                            placeholder="Hour" min="1" max={isTime24Hour ? "24" : "12"} type="number"
                                            onChange={(e) => {
                                                let name = e.target.name;
                                                let updatedTime = e.target.value;

                                                let eventCategoryCopy = { ...eventReminders[name] };
                                                eventCategoryCopy.time = updatedTime;
                                                setEventReminders(prev => ({ ...prev, [name]: eventCategoryCopy }))
                                                remindersDBupdate(name, updatedTime, timeMode, checked)
                                            }} />
                                    </Form.Group>

                                    <span className="mx-2" style={{ fontSize: "1.2rem" }}> : 00 </span>

                                    {!isTime24Hour &&
                                        <Form.Group className="d-block mb-0 mr-2" >
                                            <Form.Control
                                                name={name}
                                                as="select"
                                                value={timeMode}
                                                onChange={(e) => {
                                                    let name = e.target.name;
                                                    let updatedTimeMode = e.target.value

                                                    let eventCategoryCopy = { ...eventReminders[name] };
                                                    eventCategoryCopy.timeMode = updatedTimeMode;
                                                    setEventReminders(prev => ({ ...prev, [name]: eventCategoryCopy }))
                                                    remindersDBupdate(name, time, updatedTimeMode, checked)


                                                }}>
                                                <option value="AM"> AM </option>
                                                <option value="PM"> PM </option>

                                            </Form.Control>
                                        </Form.Group>}

                                    <Form.Group className="mb-0 mx-2">
                                        <Form.Check type="checkbox" className="custom-control custom-checkbox" name={name} checked={checked}
                                            onChange={(e) => {
                                                let name = e.target.name
                                                let updatedCheck = e.target.checked

                                                let eventCategoryCopy = { ...eventReminders[name] };
                                                eventCategoryCopy.enabled = updatedCheck;
                                                setEventReminders(prev => ({ ...prev, [name]: eventCategoryCopy }))

                                                remindersDBupdate(name, time, timeMode, updatedCheck)
                                            }}
                                        >
                                        </Form.Check>
                                    </Form.Group>
                                </Col>
                            </Row>)
                    })}

            </Card.Body>

        </Card>
    )
}

export default EventReminders;
